import { OptionSelectFormProps } from './OptionSelectForm';

export const buildOptionSelectOver30BMI_1 = (): OptionSelectFormProps => ({
  title: 'Do any of the following apply to you?',
  eyebrow: 'Tell us more...',
  tooltip:
    'We want to check if you have any conditions which make you ineligible for the program.',
  questionType: 'multiSelect',
  optionType: 'titleAndDescription',
  options: [
    {
      title: 'None of these apply to me',
      description: 'None of the following apply to me',
      isSelected: false,
      isIneligible: false,
      isExclusive: true,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Pregnant or breastfeeding',
      description:
        'Currently pregnant, trying to become pregnant or breastfeeding/providing bottled breastmilk',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Cancer or family history of certain conditions',
      description:
        'Have an active cancer diagnosis or have had cancer within the last 5 years or personal or family history of medullary thyroid cancer or multiple endocrine neoplasia type 2',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Diabetes on insulin management',
      description: 'Type 1 diabetes or type 2 diabetes treated with insulin',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Heart conditions or stroke',
      description: 'Heart attack or stroke within the last 12 months',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Diabetic retinopathy or pancreatitis',
      description:
        'Diabetic retinopathy or current/past diagnosis of pancreatitis',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
  ],
});

export const buildOptionSelectOver30BMI_2 = (): OptionSelectFormProps => ({
  title: "We're almost there...",
  eyebrow: 'One last thing...',
  tooltip: 'Do any of the following apply to you?',
  questionType: 'multiSelect',
  optionType: 'titleAndDescription',
  options: [
    {
      title: 'None of these apply to me',
      description: 'None of the following apply to me',
      isSelected: false,
      isIneligible: false,
      isExclusive: true,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Gastrointestinal diseases',
      description:
        'Severe gastrointestinal diseases such as gastroparesis, blockages, or inflammatory bowel disease',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'History of suicidal thoughts',
      description: 'Active suicidal thoughts or past suicide attempts',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'History of eating disorders',
      description:
        'Current eating disorder or a history of an eating disorder (bulimia, anorexia, binge eating disorder or other)',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'History of organ transplant on anti-rejection therapy',
      description: 'History of organ transplant on anti-rejection therapy',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Kidney or liver disease',
      description:
        'End stage kidney disease or end stage liver disease (cirrhosis)',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
  ],
});

export const buildOptionSelectOver27BMI = (): OptionSelectFormProps => ({
  title: 'Do you experience any of the following?',
  eyebrow: 'Tell us more...',
  tooltip: 'Select all that apply',
  questionType: 'multiSelect',
  optionType: 'titleOnly',
  options: [
    {
      title: 'None of these',
      isSelected: false,
      handleOptionSelection: () => ({}),
      isIneligible: false,
      isExclusive: true,
    },
    {
      title: 'Type 2 diabetes',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Prediabetes',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Hypertension',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Sleep apnea',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Cardiovascular disease',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
    {
      title: 'Hyperlipidemia',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
      handleOptionSelection: () => ({}),
    },
  ],
});
